import View from '~/app/View'

//Image and text list/rewards list
import MarketingImageTextList from '~/components/marketing/marketing-image-text-list'

//Image link slider
import ImageLinkSlider from '~/components/global/image-link-slider'

//Hero text
import MarketingHeroText from '~/components/marketing/marketing-hero-text'

import '@/templates/page.marketing.scss'

const marketingView = new View()
marketingView.init({
  MarketingImageTextList,
  ImageLinkSlider,
  MarketingHeroText
})

